import i18next from "i18next";
import { Col, Row } from "react-bootstrap";
import { CgMoreO } from "react-icons/cg";
import { StellantisQuoteRequestDTO } from "src/api/models/StellantisDTO";
import ToolTip from "../Tooltip/Tooltip";
import { useMemo } from "react";
import { StellantisConstant } from ".";

type Props = {
  type: 'request' | 'quote' | 'history';
  quoteRequest: StellantisQuoteRequestDTO;
}

function StellantisQuoteInfoTooltip({ quoteRequest, type = 'request' }: Props) {
  const elId = `info-quote-other-${quoteRequest.id}`;
  const data = quoteRequest.quote!;

  const canoneLabel = data.tipoCliente === 'privato'
    ? i18next.t('canone_with_iva')
    : i18next.t('canone_without_iva');

  const gommeInfo = `${data.tipoGomma?.toUpperCase()}  (${data?.gommeIllimitateYN ? 'Illimitate' : (data?.numTrenoGommeEstive || 0) + ' estive, ' + (data?.numTrenoGommeInvernali || 0) + ' invernale'})`;
  const sliceIdx = type === 'history' ? 6 : 5;

  const items = useMemo(() => {
    const list = [
      { key: i18next.t('annual_km'), value: data?.kmAnnui },
      { key: i18next.t('duration'), value: data?.durata + ' ' + i18next.t('months') },
      { key: i18next.t('downpayment'), value: data?.anticipoNoIva + '€' },
      { key: i18next.t('rca'), value: data?.rcaPenaleRisarcitoria + '€' },
      { key: i18next.t('kasko'), value: data?.kaskoFranchigia + '€' },
      { key: i18next.t('theft_fire'), value: data?.incendioFurtoScopertoPerc + '%' },
      { key: i18next.t('tyres'), value: data?.gommeYN ? gommeInfo : i18next.t('no') },
      { key: i18next.t('replacement_car'), value: data?.autoSostitutivaYN
          ? (StellantisConstant.vetturaSostitutivaAllOptions.find(item => item.value == data.autoSostitutivaGruppo)?.label || data.autoSostitutivaGruppo?.toUpperCase())
          : i18next.t('no') },
      { key: i18next.t('optionals'), value: data?.optionals?.length ? i18next.t('yes') : i18next.t('no') },
    ]

    if (!!data?.noleggiatore?.trim()) {
      list.push({ key: i18next.t('rental_company'), value: data?.noleggiatore });
    }

    if (type == 'history') {
      list.push(
        { key: canoneLabel, value: (data?.canone || 0) + '€' },
      )
    }

    if (['history', 'request'].includes(type)) {
      list.push(
        { key: i18next.t('provvigioni'), value: (data.provvigioni ?? 0) }
      )
    }
    return list;
  }, [data])


  const content: any = (
    <Row>
      <Col>
        {items.slice(0, sliceIdx).map((kv, idx) => (
          <div key={idx}>
            <span className='fw-bold me-2'>{kv.key}:</span>
            <span>{kv.value}</span>
          </div>
        ))}
      </Col>
      <Col>
        {items.slice(sliceIdx).map((kv, idx) => (
          <div key={idx}>
            <span className='fw-bold me-2'>{kv.key}:</span>
            <span>{kv.value}</span>
          </div>
        ))}
      </Col>
    </Row>
  )

  return (
    <div id={elId} className="fw-bold">
      <CgMoreO className="text-bold" style={{ fontWeight: 'bolder' }} size={24} />
      <ToolTip
        openOnClick={type !== 'quote'}
        clickable={type !== 'quote'}
        anchorId={elId}
        children={content}
        className="w-75"
      />
    </div>
  )
}

export default StellantisQuoteInfoTooltip;
